import { cn } from "@/lib/utils";
import { BaseEntryValue } from "./BaseEntryValue";
import type { BaseEntryValueProps } from "./BaseEntryValue";

export interface LongTextEntryValueProps
	extends Omit<BaseEntryValueProps, "value"> {
	value: string | null;
}

export function LongTextEntryValue({
	value,
	inputLabel,
	size,
	className,
	...props
}: LongTextEntryValueProps) {
	return (
		<BaseEntryValue
			inputLabel={inputLabel}
			size={size}
			className={className}
			{...props}
		>
			<p
				className={cn(
					"dark:text-slate-200",
					size === "sm" ? "text-sm" : size === "lg" ? "text-lg" : "text-base",
				)}
			>
				{value ?? "None"}
			</p>
		</BaseEntryValue>
	);
}
